(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.grouppractice');
    module.controller('LocationOverviewController', [
        'GroupPracticeService',
        'ItemTableService',
        'SharedAgendaService',
        '$uibModal',
        'HelperService',
        LocationOverviewControllerFn]);

    /* controlle for email-overview */
    function LocationOverviewControllerFn(
        GroupPracticeService,
        ItemTableService,
        SharedAgendaService,
        $uibModal,
        HelperService) {
            
        var vm = this;
        
        vm.locations = [];

        activate();

        function activate() {
            vm.groupPracticeId = SharedAgendaService.currentUser().groupPracticeId;
            if (!vm.groupPracticeId) {                
                return;
            }

            loadInternalLocations();
        }

        function loadInternalLocations() {
            GroupPracticeService.getInternalLocations(vm.groupPracticeId)
                .then(function(locations) {
                    vm.locations = locations;

                    var itemTableService = ItemTableService.Instance();
                    itemTableService.init(vm.locations);
                    vm.overview = itemTableService;
                });
        }

        vm.new = function() {
          var newLocation = {
            id: 0,
            name: '',
            description: '',
            waitingRoomId: null,
            groupPracticeId: vm.groupPracticeId
          };
          showEditModal(newLocation);
        }

        vm.edit = function(location) {
            showEditModal(location);
        }

        vm.delete = function(location) {
            var confirmationModal = HelperService.deactivatingConfirmationModal();
            confirmationModal.result.then(function() {
                return GroupPracticeService.deleteInternalLocation(vm.groupPracticeId, location.id)
                                    .then(function() {
                                       loadInternalLocations();
                                    });
            });
        }

        function showEditModal(location) {           
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/settings/grouppractice/location/location-detail.html',
                controller: 'LocationDetailController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    location: ['GroupPracticeService', function (GroupPracticeService) {
                        if (location.id <= 0) {
                            return location;
                        }
                        
                        return GroupPracticeService
                                    .getInternalLocation(vm.groupPracticeId, location.id)
                                    .then(function (location) {
                            return location;
                        });
                    }]
                }
            });

            // modal is closed
            modalInstance.result.then(function (item) {
                return loadInternalLocations();
            });
        } 
    }
})();
